var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$attrs["prop"]
    ? _c(
        "el-form-item",
        {
          attrs: {
            "label-width": _vm.$attrs["label-width"],
            prop: _vm.$attrs["prop"],
            label: _vm.$attrs["label"],
          },
          scopedSlots: _vm._u(
            [
              {
                key: "error",
                fn: function (ref) {
                  var error = ref.error
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: error,
                          placement: "left",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "el-form-item__error",
                            class: { error_box: _vm.$attrs["error"] == "true" },
                          },
                          [_vm._v(" " + _vm._s(error) + " ")]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            2937236695
          ),
        },
        [
          _c(
            "el-select",
            _vm._b(
              {
                directives: [
                  {
                    name: "select",
                    rawName: "v-select",
                    value: {
                      value: _vm.innerValue,
                      list: _vm.options,
                      directive: _vm.directive,
                    },
                    expression:
                      "{\n      value: innerValue,\n      list: options,\n      directive: directive,\n    }",
                  },
                ],
                staticClass: "vab_select",
                attrs: {
                  "popper-class": _vm.textEllipsis ? "optionsContent" : "",
                  disabled: _vm.$attrs["disabled"] || _vm.localDisabled,
                },
                on: {
                  focus: _vm.handleFocus,
                  change: _vm.onChange,
                  clear: _vm.onClear,
                },
                model: {
                  value: _vm.innerValue,
                  callback: function ($$v) {
                    _vm.innerValue = $$v
                  },
                  expression: "innerValue",
                },
              },
              "el-select",
              _vm.$attrs,
              false
            ),
            [
              _vm.textEllipsis
                ? _vm._l(_vm.options, function (item, index) {
                    return _c(
                      "el-option",
                      {
                        key: index,
                        attrs: {
                          label: item.label,
                          value: item.value,
                          disabled: item.disabled,
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: item.label,
                              disabled: item.label.length < 13,
                              placement: "right",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(item.label))])]
                        ),
                      ],
                      1
                    )
                  })
                : _vm._l(_vm.options, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: item.label,
                        value: item.value,
                        disabled: item.disabled,
                      },
                    })
                  }),
            ],
            2
          ),
        ],
        1
      )
    : _c(
        "el-form-item",
        {
          attrs: {
            "label-width": _vm.$attrs["label-width"],
            label: _vm.$attrs["label"],
          },
        },
        [
          _c(
            "el-select",
            _vm._b(
              {
                staticClass: "vab_select",
                attrs: {
                  disabled: _vm.$attrs["disabled"] || _vm.localDisabled,
                },
                on: { change: _vm.onChange, clear: _vm.onClear },
                model: {
                  value: _vm.innerValue,
                  callback: function ($$v) {
                    _vm.innerValue = $$v
                  },
                  expression: "innerValue",
                },
              },
              "el-select",
              _vm.$attrs,
              false
            ),
            _vm._l(_vm.options, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }